// extracted by mini-css-extract-plugin
export default {"wrapper":"AdditionalInfo_wrapper__y+tmQ"};